export default __webpack_public_path__ + "static/media/litho-templates-library-02.febd2bfa.jpg";